module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2fm"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/epigraph"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/maps"
    }
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue"
    }
  }, [_vm._v("Prologue: The View")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-part"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART I")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-partt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Antebellum")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("Chapter One: Foundering Father")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_vm._v("Chapter Two: A Potomac Son")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch03"
    }
  }, [_vm._v("Chapter Three: Lee’s Union")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART II")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-partt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Casus Belli")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: Half Slave, Half Free")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Washington’s Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: The Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART III")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-partt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Bellum")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: The Battle for Arlington")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: The Last Heir")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: White House Burning")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Emancipation")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: The Indispensable Man")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: The Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PART IV")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-partt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Postbellum")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: Washington and Lee")])]), _vm._v(" "), _c('p', {
    staticClass: "contb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photographs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Custis-Lee Family Tree")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/credits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map and Illustration Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0